module.exports = __webpack_public_path__ + "fonts/MrEavesModOT-Book.8c0597c2.woff2";